<template>
  <div>
    <b-sidebar
      :visible="visible"
      @hidden="noVisible"
      :title="'Create ' +module"
      backdrop-variant="dark"
      backdrop
      shadow
      right
      width="400px"
    >
      <div class="px-3 py-2">
        <form @submit.prevent="submitQuickCreate">
          <div class="row">
            <div class="col-12 grid-margin">
              <div class="form-group" v-for="(item, index) in fields_form" :key="index">
                <label>{{ item[alias_table+'_f_label'] }}</label>
                <small
                  v-if="item[alias_table+'_f_validation'] != ''"
                  class="pull-right text-danger"
                >*{{ item[alias_table+'_f_validation'] }}</small>
                <component
                  :is="item[alias_table+'_f_input_type']+'_form'"
                  :name="item[alias_table+'_f_name']"
                  :table_module="table_module"
                  :validation="item[alias_table+'_f_validation']"
                  :content="item['content']"
                  :dropdown_name="item[alias_table+'_f_options']"
                  @post="bindingData"
                  :parsing-post="post"
                  :parsing-trigger="trigger_autocomplete"
                ></component>
              </div>
            </div>
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-start">
            <button type="submit" class="btn btn-primary mr-1">Submit</button>
            <button class="btn btn-secondary mr-1" type="button" @click="noVisible()">Batal</button>
          </div>
        </form>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import year_form from "@/components/input/year";
import radio_form from "@/components/input/radio";
import s_image_form from "@/components/input/s_image";
import m_image_form from "@/components/input/m_image";
import email_form from "@/components/input/email";
import editor_form from "@/components/input/editor";
import tag_form from "@/components/input/tags";
import date_form from "@/components/input/date";
import m_option_form from "@/components/input/m_option";

export default {
  props: {
    module: {
      type: String,
      required: true,
    },
    table_module: {
      type: String,
      required: true,
    },
    alias_table: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    fields: {
      type: [Array, Object],
      required: true,
    },
    defaultValue: {
      type: [Array, Object],
    },
    uuid: {
      type: String,
    },
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    m_option_form,
    year_form,
    radio_form,
    s_image_form,
    email_form,
    m_image_form,
    editor_form,
    tag_form,
    date_form,
  },
  data() {
    return {
      post: {},
      trigger_autocomplete: "",
    };
  },
  // watch: {
  //   fields() {
  //     for (const key in this.defaultValue) {
  //       this.$set(this.post, key, this.defaultValue[key]);
  //       if (this.fields.length > 0) {
  //         let find = this.fields.findIndex(
  //           r => r[this.alias_table + "_f_name"] == key
  //         );

  //         if (find != -1) {
  //           this.$delete(this.fields, find);
  //         }
  //       }
  //     }
  //   }
  // },
  // mounted() {
  //   for (const key in this.defaultValue) {
  //     this.$set(this.post, key, this.defaultValue[key]);
  //     if (this.fields.length > 0) {
  //       let find = this.fields.findIndex(
  //         r => r[this.alias_table + "_f_name"] == key
  //       );

  //       if (find != -1) {
  //         this.$delete(this.fields, find);
  //       }
  //     }
  //   }
  // },
  computed: {
    fields_form() {
      var res = this.fields;
      for (const key in this.defaultValue) {
        this.$set(this.post, key, this.defaultValue[key]);
        if (res.length > 0) {
          let find = res.findIndex(
            (r) => r[this.alias_table + "_f_name"] == key
          );

          if (find != -1) {
            this.$delete(res, find);
          }
        }
      }
      return res;
    },
  },
  methods: {
    noVisible() {
      this.$emit("hiddenSideSearch");
    },
    submitQuickCreate(event) {
      if (this.table_module == "services") {
        this.$delete(this.post, "crs_brand_id");
      }
      if (this.uuid == null) {
        this.axios
          .post("/" + this.table_module + "/save", this.post)
          .then((response) => {
            if (response.data.status == 200) {
              this.$toast("Simpan data berhasil");
              this.$emit("fetch");
              this.$emit("hiddenSideSearch");
              event.target.reset();
            }
          });
      } else {
        var uri = "update";

        if (this.alias_table == "usr") {
          uri = "updatebyAdmin";
        }
        this.axios
          .post(
            "/" + this.table_module + "/" + uri + "/" + this.uuid,
            this.post
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.$toast("Simpan data berhasil");
              this.$emit("fetch");
              this.$emit("hiddenSideSearch");
              event.target.reset();
            }
          });
      }
    },
    bindingData: function (value) {
      if (value["value"] == null || value["value"] === "") {
        if (this.table_module == "services_bulk" && value["name"] == "srv_id") {
          this.$children.forEach((element, key) => {
            if (element.name == "srv_id") {
              this.$children[key].post = [];
              this.$children[key].extra = {};
              this.$children[key].list = {};
            }
          });
        }
        this.$delete(this.post, value["name"]);
      } else {
        if (value.name == "prd_image") {
          if (this.post[value.name] == undefined) {
            var arr = [];
            arr.push(value["value"]);
            this.$set(this.post, value["name"], arr);
          } else {
            this.post[value.name].push(value["value"]);
          }
        } else {
          this.$set(this.post, value["name"], value["value"]);
          if (value.name == "crs_brand_id") {
            this.trigger_autocomplete =
              Math.floor(100000 + Math.random() * 900000) + "_crs_model_id";
          }
        }
      }
    },
  },
};
</script>